import { extend, configure } from "vee-validate";
import * as rules from "vee-validate/dist/rules";
import th from "vee-validate/dist/locale/th";

import i18n from "./i18n";
configure({
  defaultMessage: (field, values) => {
    // override the field name.
    values._field_ = i18n.t(`${field}`);

    return i18n.t(`validation.${values._rule_}`, values);
  },
});

// loop over all rules
for (let rule in rules) {
  extend(rule, {
    ...rules[rule], // add the rule
    message: th.messages[rule], // add its message
  });
}

// extend("phoneno", {
//   validate: (value) => {
//     return /((\(?(\+\s*)([0-9]{2,3})\)?\s*[0]?)|[0])(([1-9][0-9]?))\s*\-?\s*([0-9]{3})\s*\-?\s*([0-9]{4,5})/.test(
//       value
//     );
//   },
//   message: "กรุณากรอกเบอร์โทรให้ถูกต้อง",
// });
